<div class="k-i-loading" *ngIf="show">
  <div class="k-i-loading-mask"></div>
  <div class="k-i-loading-wrapper">
    <div class="k-i-loading-text">
      <p> {{message}}</p> 
    </div>
  </div>
</div>
